import { h } from 'preact'
import MethodBox from './MethodBox'
import LogoNoText from '../assets/logo-no-text'
import Switcher from '../control/Switcher'

interface Props {
  isEnabled: boolean,
  toggle: () => void
}

const DefaultAuthenticationBox = ({ isEnabled, toggle }: Props) =>
  <MethodBox providerName='default'>
    <LogoNoText />
    <div>
      <div class='method-default'>Default authentication</div>
      <div class='method-description'>inSided's default authentication method: email, username and password</div>
    </div>
    <Switcher
      on={isEnabled}
      onChange={() => toggle()}
    />
  </MethodBox>

export default DefaultAuthenticationBox
